import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { _ as _objectSpread2 } from '../../dist/objectSpread2-811c5212.esm.js';
import _typeof from '@babel/runtime/helpers/esm/typeof';
import { notNil } from '../../nil/dist/uswitch-ev-utils-nil.esm.js';

var isObject = function isObject(value) {
  return _typeof(value) === 'object' && value !== null && !Array.isArray(value);
};
var pick = function pick(arr, obj) {
  return arr.reduce(function (acc, it) {
    return it in obj ? _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, it, obj[it])) : acc;
  }, {});
};
var omit = function omit(arr, obj) {
  return Object.entries(obj).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      a = _ref2[0];
      _ref2[1];
    return !arr.includes(a);
  }).reduce(function (acc, _ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      val = _ref4[1];
    return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, key, val));
  }, {});
};
var path = function path(arr, obj) {
  var def = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  return arr.reduce(function (acc, it) {
    return acc !== def && {}.hasOwnProperty.call(acc, it) ? acc[it] : def;
  }, obj);
};
var isEmpty = function isEmpty() {
  var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return val === null || !(Object.keys(val) || val).length;
};
var nonEmpty = function nonEmpty() {
  var o = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var def = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var res = Object.entries(o).filter(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
      val = _ref6[1];
    return notNil(val);
  }).reduce(function (acc, _ref7) {
    var _ref8 = _slicedToArray(_ref7, 2),
      key = _ref8[0],
      val = _ref8[1];
    return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, key, val));
  }, {});
  return isEmpty(res) ? def : res;
};

/**
 * Map over an objects entries
 *
 * @param {Function} f - Function to apply to tuples of Key/Values
 * @param {Object} obj - The object to map over
 */
var mapObj = function mapObj() {
  var f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (i) {
    return i;
  };
  var obj = arguments.length > 1 ? arguments[1] : undefined;
  return Object.entries(obj).reduce(function (acc, _ref9) {
    var _ref10 = _slicedToArray(_ref9, 2),
      key = _ref10[0],
      val = _ref10[1];
    return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, key, f(val)));
  }, {});
};

/**
 * Chunks an array into smaller arrays of a specified size.
 *
 * Use Array.from() to create a new array, that fits the number of
 * chunks that will be produced. Use Array.prototype.slice() to map
 * each element of the new array to a chunk the length of size. If the
 * original array can't be split evenly, the final chunk will contain
 * the remaining elements.
 *
 * @param {Array} arr - List of items to chunk
 * @param {number} size - The size of each chunk
 * @returns {Array}
 */
var chunk = function chunk(arr, size) {
  return Array.from({
    length: Math.ceil(arr.length / size)
  }, function (v, i) {
    return arr.slice(i * size, i * size + size);
  });
};
var compose = function compose() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }
  return fns.reduce(function (f, g) {
    return function () {
      return f(g.apply(void 0, arguments));
    };
  });
};
var unpick = function unpick(arr, obj) {
  return Object.entries(obj).reduce(function (acc, _ref11) {
    var _ref12 = _slicedToArray(_ref11, 2),
      key = _ref12[0],
      val = _ref12[1];
    return arr.includes(key) ? acc : _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, key, val));
  }, {});
};

/**
 * Takes an object with arrays as properties, and returns an array of objects
 * with the same keys, but with values so that every possible permutation of
 * properties is covered.
 *
 * Example
 * For {foo: [1, 2], bar: [3, 4]}, this function returns:
 * [{foo: 1, bar 3}, {foo: 1, bar: 4}, {foo: 2, bar: 3}, {foo: 2, bar: 4}]
 *
 * @param {Object} permutationsObject
 * @returns {Array} - each element is a permutation
 */
var permutationsGenerator = function permutationsGenerator(permutationsObject) {
  if (!Object.keys(permutationsObject).length) {
    return [{}];
  }
  var permutationsArray = [];
  var _Object$entries$ = _slicedToArray(Object.entries(permutationsObject)[0], 2),
    objectKey = _Object$entries$[0],
    objectValues = _Object$entries$[1];
  var omittedObject = _objectSpread2({}, permutationsObject);
  delete omittedObject[objectKey];
  var recursiveValues = permutationsGenerator(omittedObject);
  objectValues.forEach(function (value) {
    recursiveValues.forEach(function (values) {
      permutationsArray.push(_objectSpread2(_defineProperty({}, objectKey, value), values));
    });
  });
  return permutationsArray;
};

export { chunk, compose, isEmpty, isObject, mapObj, nonEmpty, omit, path, permutationsGenerator, pick, unpick };
